define([
	"csi/action/Excel",
	"csi/def/ActionFactory"
], function(Excel,ActionFactory) {

	return ActionFactory.declare("tableExcelSwitchboard", Excel, {
		confirmAction: "EXPORT",
		
		constructor: function() {
			this.m_id = "TableExcelSwitchboard";
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: disable action if switchboard is empty (no root node on view)
			return ctx.view.getViewNode() && this.inherited(arguments);
		},
	
		validate: function(/*Context*/ctx) {
			// summary: switchboard plugin must explicitly enable export to excel for all switchboard entries
			var	switchboard = ctx.view.getSwitchboard();
			return switchboard && switchboard.bSupportsExcel && this.inherited(arguments);
		},
	
		_getNameParams: function(/*LocaleResolver*/lr) {
			// summary: return array of parameters used to help name action
			return [lr.getTypeName(this.m_rcTarget.getType()), lr.getTypePlural(this.m_rcTarget.getType())];
		}
	});
});